<template>
  <van-popup :value="showDatePicker" round position="bottom" @click-overlay="$emit('update:showDatePicker', false)">
    <van-datetime-picker
      title="请选择年月"
      :value="date"
      type="year-month"
      @cancel="$emit('update:showDatePicker', false)"
      @confirm="handleConfirm"
    />
  </van-popup>
</template>

<script>
import dayJS from 'dayjs';
import { getMonthStartTime, getMonthEndTime, currentMonth } from '@/utils';
export default {
  name: 'MonthPicker',
  props: {
    currentDate: {
      type: String,
      required: true
    },
    showDatePicker: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    date() {
      const month = dayJS(this.currentDate).toDate()
      return month.toString() !== 'Invalid Date' ? month : dayJS(currentMonth).toDate();
    }
  },
  methods: {
    handleConfirm(value) {
      const date = dayJS(value).format('YYYY-MM');
      const startTime = getMonthStartTime(date);
      const endTime = getMonthEndTime(date);
      this.$emit('update:currentDate', date);
      this.$emit('changeDate', { startTime, endTime });
      this.$emit('update:showDatePicker', false);
    }
  }
}
</script>

<style lang="less" scoped>

</style>